import React from 'react';
import { pick, get } from 'lodash';
import {  useGetFullAddress, useRequestAddress, useSelect } from '../hooks';
import moment from 'moment';
import { Route } from 'react-router-dom';
import { ExistingFranchiseList, AuthorizedDriversList, ServiceUnits } from '../components';
import ReuploadRequiredDocuments from './ReuploadRequiredDocuments';
import RequiredDocuments, { options as requiredDocumentsOptions } from './RequiredDocuments';


const ApplicationFullInformation = ({ type,  value }) => {
 
  useRequestAddress(null, 
    get(value, 'region_id'), 
    get(value, 'province_id'),
    get(value, 'municipality_id'),
    get(value, 'barangay_id'),
  )

  useRequestAddress('mailing_', 
    get(value, 'mailing_region_id'), 
    get(value, 'mailing_province_id'),
    get(value, 'mailing_municipality_id'),
    get(value, 'mailing_barangay_id'),
  )

  useRequestAddress('representative_', 
    get(value, 'representative_region_id'), 
    get(value, 'representative_province_id'),
    get(value, 'representative_municipality_id'),
    get(value, 'representative_barangay_id'),
  )

  const businessAddress = useGetFullAddress(value)
  const mailingAddress = useGetFullAddress(value, 'mailing_')
  const garageAddress = useGetFullAddress(value, 'garage_')
  const representativeAddress = useGetFullAddress(value, 'representative_')

  const selectedServiceType = useSelect('serviceType.selected', { id: value.service_type_id })
  const selectedRoute = useSelect('route.selected', { id: value.route_id })

  return (
    <>
      <b className="text-success font-medium">Basic Information</b>
      {type === 'individual' &&
        <>
          <div className="grid grid-cols overflow-hidden">
            <ApplicationFullInformation.Item label="First Name" value={value.first_name || '-'}/>
            <ApplicationFullInformation.Item label="Middle Name" value={value.middle_name || '-'}/>
            <ApplicationFullInformation.Item label="Last Name" value={value.last_name || '-'}/>
            <ApplicationFullInformation.Item label="Extension Name" value={value.extension_name || '-'}/>
          </div>
          <div className="grid grid-cols overflow-hidden">
            <ApplicationFullInformation.Item label="Gender" value={value.gender || '-'}/>
            <ApplicationFullInformation.Item label="Birth Date" value={value.birth_date ? moment(value.birth_date).format('MMM DD, YYYY') : '-'}/>
            <ApplicationFullInformation.Item label="TIN Number" value={value.tin_number || '-'}/>
            <ApplicationFullInformation.Item label="Email" value={value.email || '-'}/>
          </div>
        </>
      }
      {type === 'other' &&
        <>
          <div className="grid grid-cols overflow-hidden">
            <ApplicationFullInformation.Item labelClassName="w-4/12" className="col-span-3" label="Name of Corporation/Cooperatives/Other" value={value.name || '-'}/>
            <ApplicationFullInformation.Item label="SEC/CDA Registration Number" value={value.sec_cda_registration_number || '-'}/>
          </div>
        </>
      }
      <div className="grid grid-cols overflow-hidden">
        <ApplicationFullInformation.Item label="Contact Number" value={value.contact_number || '-'}/>
      </div>
      <div className="grid grid-cols overflow-hidden">
        <ApplicationFullInformation.Item label="Business Address" value={businessAddress}/>
      </div>
      <div className="grid grid-cols overflow-hidden">
        <ApplicationFullInformation.Item label="Mailing Address" value={mailingAddress}/>
      </div>
      {(value.representative_first_name && value.representative_first_name !== '') &&
        <>
          <br/>
          <b className="text-success font-medium">Representative</b>
          <div className="grid grid-cols overflow-hidden">
            <ApplicationFullInformation.Item label="First Name" value={value.representative_first_name || '-'}/>
            <ApplicationFullInformation.Item label="Middle Name" value={value.representative_middle_name || '-'}/>
            <ApplicationFullInformation.Item label="Last Name" value={value.representative_last_name || '-'}/>
            <ApplicationFullInformation.Item label="Extension Name" value={value.representative_extension_name || '-'}/>
          </div>
          <div className="grid grid-cols overflow-hidden">
            <ApplicationFullInformation.Item label="Gender" value={value.representative_gender || '-'}/>
            <ApplicationFullInformation.Item label="Birth Date" value={value.representative_birth_date ? moment(value.representative_birth_date).format('MMM DD, YYYY') : '-'}/>
            <ApplicationFullInformation.Item label="TIN Number" value={value.representative_tin_number || '-'}/>
            <ApplicationFullInformation.Item label="Email" value={value.representative_email || '-'}/>
          </div>
          <div className="grid grid-cols overflow-hidden">
            <ApplicationFullInformation.Item label="Contact Number" value={value.representative_contact_number || '-'}/>
          </div>
          <div className="grid grid-cols overflow-hidden">
            <ApplicationFullInformation.Item label="Address" value={representativeAddress}/>
          </div>
        </>
      }
      <br/>
      <b className="text-success font-medium">Unit Information</b>
      <div className="grid grid-cols overflow-hidden">
        <ApplicationFullInformation.Item label="No. of Authorized Units" value={value.number_of_authorized_units || '-'}/>
        <ApplicationFullInformation.Item label="Type of Service" value={get(selectedServiceType, 'attributes.name') || '-'}/>
      </div>
      <div className="grid grid-cols overflow-hidden">
        <ApplicationFullInformation.Item label="Garage Dimension" value={value.garage_dimension || '-'}/>
        <ApplicationFullInformation.Item label="Number of units per garage" value={value.number_of_units_per_garage || '-'}/>
      </div>
      <div className="grid grid-cols overflow-hidden">
        <ApplicationFullInformation.Item label="Owned ?" value={+value.is_owned === 1 ? 'YES' : 'NO'}/>
        <ApplicationFullInformation.Item label="Leased ?" value={+value.is_leased === 1 ? 'YES' : 'NO'}/>
        <ApplicationFullInformation.Item label="Route" value={get(selectedRoute, 'attributes.name') || '-'}/>
        <ApplicationFullInformation.Item label="Route Other" value={value.route_other || '-'}/>
      </div>
      <div className="grid grid-cols overflow-hidden mb-1">
        <ApplicationFullInformation.Item label="Garage Address" value={garageAddress}/>
      </div>
      <br/>
      <b className="text-success font-medium">Service Units</b>
      <div className="p-1 mb-1">
        <ServiceUnits readOnly data={value.service_units}/>
      </div>
      <br/>
      {get(selectedServiceType, 'attributes.name') !== 'TNVS' && 
        <>
          <b className="text-success font-medium">Existing Franchise</b>
          <div className="p-1 mb-1">
            <ExistingFranchiseList readOnly data={value.existing_franchises}/>
          </div>
          <br/>
        </>
      }
      <b className="text-success font-medium">Authorized Drivers</b>
      <div className="p-1">
        <AuthorizedDriversList readOnly data={value.authorized_drivers}/>
      </div>
      <br />
      <b className="text-success font-medium">Requirements</b>
      <Route path="/application/:id/(view|resubmit)" render={() => {
        return (
          <>
            <ReuploadRequiredDocuments preview initialValue={pick(value, Object.keys(requiredDocumentsOptions.initialFormData))}/>
            {/* <ViewSignature value={value}/>
            <ResubmitApplication paymentId={value.cpc_application_id}/> */}
          </>
        )
      }}/>
      <Route path="/application-form" render={() => {
        return (
          <>
            <RequiredDocuments preview initialValue={pick(value, Object.keys(requiredDocumentsOptions.initialFormData))}/>
          </>
        )
      }}/>
      
    </>
  )
}


ApplicationFullInformation.Item = ({ label, value, className, labelClassName }) => {
  return (
    <div className={`flex flex-col xl:flex-row lg:flex-row space-x-0 xl:space-x-2 lg:space-x-2 items-start xl:items-center lg:items-center ${className}`}>
      <span className={`w-auto xl:w-64 lg:w-48 text-sm text-gray-600 ${labelClassName}`}>{label} <b className="float-right">:</b></span>
      <span className="font-medium text-sm">{value}</span>
    </div>
  )
}

export default ApplicationFullInformation